import styled from 'styled-components';

export const Content = styled.div``;

export const Input = styled.div`
  height: 100%;
  position: relative;
`;
